var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiltroBarra(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00016 0.333344C3.3135 0.333344 0.333496 3.31334 0.333496 7.00001C0.333496 10.6867 3.3135 13.6667 7.00016 13.6667C10.6868 13.6667 13.6668 10.6867 13.6668 7.00001C13.6668 3.31334 10.6868 0.333344 7.00016 0.333344ZM10.3335 9.39334L9.3935 10.3333L7.00016 7.94001L4.60683 10.3333L3.66683 9.39334L6.06016 7.00001L3.66683 4.60668L4.60683 3.66668L7.00016 6.06001L9.3935 3.66668L10.3335 4.60668L7.94016 7.00001L10.3335 9.39334Z",
    fill: "#F0FFFF",
    fillOpacity: 0.26
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltroBarra);
export default __webpack_public_path__ + "static/media/filtro_barra.62d23294bd01fbc44c5cb9766c97f452.svg";
export { ForwardRef as ReactComponent };